import { render, staticRenderFns } from "./CompanyGroupHelp.vue?vue&type=template&id=71385451&"
import script from "./CompanyGroupHelp.vue?vue&type=script&lang=js&"
export * from "./CompanyGroupHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports